<script>
import ExactSearch from "@/mixins/exactSearch";
export default {
  mixins: [ExactSearch],
  props: {
    tenementCode: [String, Number],
  },
  beforeCreate() {
    this.fields = ["roleName", "roleCode", "createUser"];
  },
  mounted() {
    if (this.$store.state.app.tenementInfoObj) {
      this.handleSearch();
    }
  },
  methods: {
    getFieldTpls(model) {
      model.roleName = _.trim(model.roleName);
      model.roleCode = _.trim(model.roleCode);
      model.createUser = _.trim(model.createUser);
      const tpls = {
        roleName: (
          <el-form-item label={`${this.$t('language.5o6uj7uysto0')}`}>
            <el-input v-model={model.roleName} maxlength={30} clearable />
          </el-form-item>
        ),
        roleCode: (
          <el-form-item label={`${this.$t('language.5o6uj7uysxs0')}`}>
            <el-input v-model={model.roleCode} maxlength={30} clearable />
          </el-form-item>
        ),
        createUser: (
          <el-form-item label={`${this.$t('language.5o6trh9vn2w0')}`}>
            <el-input v-model={model.createUser} clearable />
          </el-form-item>
        ),
      };
      return tpls;
    },
    toEnd() {
      const query = { ...this.query, tenementCode: this.tenementCode };
      jt.object.removeEmptyAttr(query);
      return query;
    },
  },
};
</script>
